export default __webpack_public_path__ + "static/media/ic-quesion-white.35f66106.svg";